import { updateImageGalleryOnboardDismissed as updateImageGalleryAction } from "../../store/actionCreators";
import { setImageGalleryOnboardDismissedFromCookie } from "../helpers/imageGalleryOnboardDismissed";

export const updateImageGalleryOnboardDismissed = imageGalleryOnboardDismissed => {
  setImageGalleryOnboardDismissedFromCookie(imageGalleryOnboardDismissed);

  return updateImageGalleryAction(imageGalleryOnboardDismissed);
};
